import type { FormRule } from 'antd';
import type { IExpenseFormFields } from './types';

export const validationRules: Record<keyof IExpenseFormFields, FormRule[]> = {
  clientNumber: [{ required: false, type: 'string' }],
  typeId: [{ required: true, type: 'number' }],
  price: [{ required: true, type: 'number', min: 0.01 }],
  currency: [{ required: true, type: 'string' }],
  endDate: [{ required: true }],
  partner: [{ required: false, type: 'object' }],
  contact: [{ required: false, type: 'object' }],
};
